import be from './Belgium';
import de from './Germany';

const features = {
  be,
  de,
};

export default features;
